<section class="sliderSearch mt-lg-0  p-0">
    <div class="container-fluid w-100 align-items-center d-flex justify-content-center position-relative " id="bg-slider" [ngStyle]="{'background-image': 'url(' + sliderImage + ')'}">
        <div class="container">
            <div class="row searchMainDiv justify-content-center m-0">
                <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 searchBox">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 p-0 mb-3">
                        <h1 style="font-size:1.7rem" class="text-white">Properties to {{getSelectedCity.showCategoryLabel}} in <strong class="bold">{{getSelectedCity.name}}</strong></h1>
                        <div class="text-white">Your Local Property Expert</div>
                    </div>
                    <div class="row headerssflat align-items-center d-flex justify-content-center text-center">
                        <!--<p>Find a place that suits all your real estate need and desires.</p>-->
                        <a href="javascript: void(0);" (click)="mobileSearchFilter()" class="form-control border-right-1 border-light input-box responsive-search text-left border-0 mb-0 d-none"><i class="ti-location-pin"></i> Search by
                            Location or Type </a>
                        <div class="bay-sell-rent w-100 h-100 p-0 text-left" id="search-box">
                            <div class="mobileSearchBack search-header border-bottom border-light d-none bg-white"><i class="ti-arrow-left" (click)="closeSearchFilter()"></i> Search
                            </div>
                            <nav class="elasticTabs w-100 my-0 float-left list-unstyled p-2 px-3 p-md-0 mb-3 mb-md-0">
                                <a class="position-relative d-inline-block text-center text-white" [class.active]="searchCategory=='buy'" href="#buy" data-toggle="pill" (click)="getBanner('buy')">Buy</a>
                                <a class="position-relative d-inline-block text-center text-white" [class.active]="searchCategory=='rent'" href="#rent" data-toggle="pill" (click)="getBanner('rent')">Rent</a>
                                <a class="position-relative d-inline-block text-center text-white" [class.active]="searchCategory=='pg'" href="#pg" data-toggle="pill" (click)="getBanner('pg')">PG</a>
                                <a class="position-relative d-inline-block text-center text-white" [class.active]="searchCategory=='findAnAgent'" href="#findAnAgent" data-toggle="pill" (click)="getBanner('findAnAgent')">Find an
                                    Agent </a>
                            </nav>
                            <div class="tab-content w-100 float-left">
                                <div class="tab-pane container active" id="home">
                                    <div class="row">

                                        <form class="form-inline sarech-box-area p-0 my-0 mx-auto w-100 rounded-0 align-items-start" [formGroup]="homeSearch" (ngSubmit)="searchProperty()">
                                            <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pd-0" [ngStyle]="{'display': (searchCategory=='findAnAgent') ? 'block' : 'none'}">
                                                <div class="form-control border-right-1 border-light w-100 text-left">Agents by location</div>
                                            </div> -->
                                            <!-- <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-12 bg-white my-1 my-sm-0 pd-0" >
                                                <input type="text" class="form-control border-right-1 border-light input-box position-relative mb-0"  placeholder="city">
                                                <i class="ti-angle-down" style="position:absolute; right:10px; font-size:10px;top:19px;"></i>
                                              
                                            </div> -->
                                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 ng-autocomplete nes  form-control border-right-1 border-light  mb-0 pac-target-input" *ngIf="searchCategory=='buy' || searchCategory=='rent' || searchCategory=='pg' || searchCategory=='findAnAgent'">
                                                <ng-autocomplete (inputCleared)="CityInputFocused()" (selected)="getCity($event)" [initialValue]="initialValue" [data]="cityList" [searchKeyword]="keyword" placeHolder="Enter City" [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" class="position-relative">


                                                </ng-autocomplete>
                                                <span class="focus-input100"></span>
                                                <span class="symbol-input100 position-absolute"> <i id="like" class="ti-angle-down" ></i></span>
                                                <ng-template #itemTemplate let-item>
                                                    <div class="item">
                                                        <span [innerHTML]="item.name"></span>
                                                    </div>
                                                </ng-template>
                                                <ng-template #notFoundTemplate let-notFound>
                                                    <div [innerHTML]="notFound">City Not found.</div>
                                                </ng-template>
                                            </div>

                                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pd-0" [ngStyle]="{'display': (searchCategory=='findAnAgent') ? 'block' : 'none'}">
                                                <div class="form-control border-right-1 border-light w-100 text-left">Agents by location</div>
                                            </div>
                                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 bg-white my-1 my-sm-0 pd-0" [ngStyle]="{'display': (searchCategory=='findAnAgent') ? 'none' : 'block'}">
                                                <input type="text" class="form-control border-right-1 border-light input-box position-relative mb-0" id="id01" [value]="propertyTypeValue()" readonly>
                                                <i class="ti-angle-down" style="position:absolute; right:10px; font-size:10px;top:19px;"></i>
                                                <div class="position-absolute bg-white overflow-hidden ml-0" id="flatoftype" onclick="event.stopPropagation()">
                                                    <div class="cScroll" id="search-property-type">
                                                        <div class="card mb-0 rounded-0 border-top-0 border-0" *ngIf="(searchCategory=='buy' || searchCategory=='rent')">
                                                            <label class="d-block py-1 px-4 m-0 text-left " data-toggle="collapse" href="#collapse1">
                                                                <input class="position-absolute opacity-0 d-none" type="radio" formControlName="looking_type"
                                                                    value="1" (click)="selectCategory('1')">Residential
                                                                <span class="checkmark position-absolute bg-white"></span>
                                                            </label>
                                                            <div id="collapse1" class="collapse" data-parent="#search-property-type">
                                                                <ul class="list-unstyled m-0">
                                                                    <li *ngIf="searchCategory=='buy' || searchCategory=='rent' ">
                                                                        <label class="d-block position-relative py-1 pl-4 bg-white border-0 text-left"><input type="checkbox" id="checkbox1"
                                                                                (change)=" setPropertySubCatValue($event)"
                                                                                [checked]="chkSearchSubTypeValue('1')=='1'"
                                                                                class="checkbox subcat"
                                                                                name="residential"
                                                                                value="1">Apartment/Flat/Builder Floor
                                                                            <span class="checkmark position-absolute bg-white"></span></label></li>
                                                                    <li *ngIf="searchCategory=='buy' || searchCategory=='rent'">
                                                                        <label class="d-block position-relative py-1 pl-4 bg-white border-0 text-left"><input type="checkbox" id="checkbox2"
                                                                                (change)="setPropertySubCatValue($event)"
                                                                                [checked]="chkSearchSubTypeValue('2')=='2'"
                                                                                class="checkbox subcat"
                                                                                name="residential" value="2">Independent
                                                                            House<span class="checkmark position-absolute bg-white"></span></label>
                                                                    </li>
                                                                    <li *ngIf="searchCategory=='buy' || searchCategory=='rent' ">
                                                                        <label class="d-block position-relative py-1 pl-4 bg-white border-0 text-left"><input type="checkbox" id="checkbox4"
                                                                                (change)=" setPropertySubCatValue($event)"
                                                                                [checked]="chkSearchSubTypeValue('4')=='4'"
                                                                                class="checkbox subcat"
                                                                                name="residential"
                                                                                value="4">Plot/Land<span
                                                                                class="checkmark position-absolute bg-white"></span></label>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="card mb-0 rounded-0 border-top-0 border-0" *ngIf="(searchCategory=='buy' || searchCategory=='rent')">
                                                            <label class="d-block py-1 px-4 m-0 text-left" data-toggle="collapse" href="#collapse2">
                                                                <input class="position-absolute opacity-0 d-none" type="radio" formControlName="looking_type"
                                                                    value="2" (click)="selectCategory('2')">Commercial
                                                                <span class="checkmark position-absolute bg-white"></span>
                                                            </label>
                                                            <div id="collapse2" class="collapse" data-parent="#search-property-type">
                                                                <ul class="list-unstyled m-0">
                                                                    <li *ngIf="searchCategory=='buy' || searchCategory=='rent' ">
                                                                        <label class="d-block position-relative py-1 pl-4 bg-white border-0 text-left"><input type="checkbox" id="checkbox5"
                                                                                (change)=" setPropertySubCatValue($event)"
                                                                                class="checkbox subcat"
                                                                                name="commercial"
                                                                                [checked]="chkSearchSubTypeValue('5')=='5'"
                                                                                value="5">Shops/Showroom <span
                                                                                class="checkmark position-absolute bg-white"></span></label></li>
                                                                    <li *ngIf="searchCategory=='buy' || searchCategory=='rent' ">
                                                                        <label class="d-block position-relative py-1 pl-4 bg-white border-0 text-left"><input type="checkbox" id="checkbox6"
                                                                                (change)=" setPropertySubCatValue($event)"
                                                                                class="checkbox subcat"
                                                                                name="commercial"
                                                                                [checked]="chkSearchSubTypeValue('6')=='6'"
                                                                                value="6">Commercial Office/Space <span
                                                                                class="checkmark position-absolute bg-white"></span></label></li>
                                                                    <li *ngIf="searchCategory=='buy' || searchCategory=='rent' ">
                                                                        <label class="d-block position-relative py-1 pl-4 bg-white border-0 text-left"><input type="checkbox" id="checkbox7"
                                                                                (change)=" setPropertySubCatValue($event)"
                                                                                class="checkbox subcat"
                                                                                name="commercial"
                                                                                [checked]="chkSearchSubTypeValue('commercialland')=='commercialland'"
                                                                                value="commercialplot">Commercial Plot/Land <span
                                                                                class="checkmark position-absolute bg-white"></span></label></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="card mb-0 rounded-0 border-top-0 border-0" *ngIf="(searchCategory=='buy' || searchCategory=='rent')">
                                                            <label class="d-block py-1 px-4 m-0 text-left" data-toggle="collapse" href="#collapse3">
                                                                <input class="position-absolute opacity-0 d-none" type="radio" formControlName="looking_type"
                                                                    value="3" (click)="selectCategory('3')">Agriculture
                                                                <span class="checkmark position-absolute bg-white"></span>
                                                            </label>
                                                            <div id="collapse3" class="collapse" data-parent="#search-property-type">
                                                                <ul class="list-unstyled m-0">
                                                                    <li *ngIf="searchCategory=='buy'"><label class="d-block position-relative py-1 pl-4 bg-white border-0 text-left"><input
                                                                                type="checkbox" id="checkbox8"
                                                                                (change)=" setPropertySubCatValue($event)"
                                                                                name="commercial"
                                                                                [checked]="chkSearchSubTypeValue('8')=='8'"
                                                                                value="8"
                                                                                class="checkbox subcat">Agriculture
                                                                            Land<span class="checkmark position-absolute bg-white"></span></label>
                                                                    </li>
                                                                    <li *ngIf="searchCategory=='buy' || searchCategory=='rent' ">
                                                                        <label class="d-block position-relative py-1 pl-4 bg-white border-0 text-left"><input type="checkbox" id="checkbox9"
                                                                                (change)=" setPropertySubCatValue($event)"
                                                                                name="commercial"
                                                                                [checked]="chkSearchSubTypeValue('9')=='9'"
                                                                                value="9"
                                                                                class="checkbox subcat">Farmhouse<span
                                                                                class="checkmark position-absolute bg-white"></span></label>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="card mb-0 rounded-0 border-top-0 border-0" *ngIf="(searchCategory=='buy' || searchCategory=='rent')">
                                                            <label class="d-block py-1 px-4 m-0 text-left" data-toggle="collapse" href="#collapse4">
                                                                <input class="position-absolute opacity-0 d-none" type="radio" formControlName="looking_type"
                                                                    value="4" (click)="selectCategory('4')">Industrial
                                                                <span class="checkmark position-absolute bg-white"></span>
                                                            </label>
                                                            <div id="collapse4" class="collapse" data-parent="#search-property-type">
                                                                <ul class="list-unstyled m-0">
                                                                    <li *ngIf="searchCategory=='buy' || searchCategory=='rent' ">
                                                                        <label class="d-block position-relative py-1 pl-4 bg-white border-0 text-left"><input type="checkbox" id="checkbox10"
                                                                                (change)=" setPropertySubCatValue($event)"
                                                                                name="commercial"
                                                                                [checked]="chkSearchSubTypeValue('10')=='10'"
                                                                                value="10"
                                                                                class="checkbox subcat">Land<span
                                                                                class="checkmark position-absolute bg-white"></span></label></li>
                                                                    <li *ngIf="searchCategory=='buy' || searchCategory=='rent' ">
                                                                        <label class="d-block position-relative py-1 pl-4 bg-white border-0 text-left"><input type="checkbox" id="checkbox11"
                                                                                (change)=" setPropertySubCatValue($event)"
                                                                                name="commercial"
                                                                                [checked]="chkSearchSubTypeValue('13')=='13'"
                                                                                value="13"
                                                                                class="checkbox subcat">Factory<span
                                                                                class="checkmark position-absolute bg-white"></span></label>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="card mb-0 rounded-0 border-top-0 border-0" *ngIf="(searchCategory=='pg')">
                                                            <ul class="list-unstyled m-0 pl-0">
                                                                <li><label class="d-block position-relative px-4 py-1 border border-top-0 border-left-0 border-right-0 text-left"><input type="checkbox" id="checkbox1"
                                                                            (click)=" setPropertySubCatValue($event)"
                                                                            name="commercial"
                                                                            [checked]="chkSearchSubTypeValue('1')=='1'"
                                                                            value="1" class="checkbox subcat">Male<span
                                                                            class="checkmark position-absolute bg-white"></span></label></li>
                                                                <li><label class="d-block position-relative px-4 py-1 border border-left-0 border-right-0 text-left"><input type="checkbox" id="checkbox2"
                                                                            (click)=" setPropertySubCatValue($event)"
                                                                            name="commercial"
                                                                            [checked]="chkSearchSubTypeValue('2')=='2'"
                                                                            value="2"
                                                                            class="checkbox subcat">Female<span
                                                                            class="checkmark position-absolute bg-white"></span></label></li>
                                                                <li><label class="d-block position-relative px-4 py-1 border border-bottom-0 border-left-0 border-right-0 text-left"><input type="checkbox" id="checkbox3"
                                                                            (click)=" setPropertySubCatValue($event)"
                                                                            name="commercial"
                                                                            [checked]="chkSearchSubTypeValue('3')=='3'"
                                                                            value="3" class="checkbox subcat">Both<span
                                                                            class="checkmark position-absolute bg-white"></span></label></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12 bg-white my-1 my-sm-0 pd-0 tax-wrap d-flex" *ngIf="display">
                                                <input id="form-tags-4" ngx-google-places-autocomplete [value]="homeSearch.value.location" (keyup)="handleAddressChange($event,'mannual')" (onAddressChange)="handleAddressChange($event,'address')" name="location" placeholder='Type location or landmark'
                                                    [options]="options" required class="form-control border-right-1 border-light input-box mb-0" />
                                            </div>

                                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 bg-white my-1 my-sm-0 pd-0">
                                                <button type="button" class="btn btn-primary finder-brn w-100 shadow-none text-white border-0 rounded-0 align-items-center d-flex d-sm-inline-block justify-content-center text-white py-2 px-2" (click)="searchProperty()">
                                                    <i class="ti-search text-white mr-1" aria-hidden="true"></i> Search
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="box-min-outer" style="display: none;">
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <div class="box-outer">
                    <div class="box-img">
                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/images/trac.png" loading="lazy" alt="img" width="80" height="80">
                    </div>
                    <h4>Track your property</h4>
                    <a href="#">Track the estimated value of your home and stay in touch with your local market.</a>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="box-outer">
                    <div class="box-img">
                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/images/research.png" loading="lazy" alt="img" width="80" height="80">
                    </div>
                    <h4>Research suburbs</h4>
                    <a href="#">Track the estimated value of your home and stay in touch with your local market.</a>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="box-outer">
                    <div class="box-img">
                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/images/sell.png" loading="lazy" alt="img" width="80" height="80">
                    </div>
                    <h4>Sell or stay?</h4>
                    <a href="#">Track the estimated value of your home and stay in touch with your local market.</a>
                </div>
            </div>
        </div>
    </div>
</section>



<div class="container-fluid paddEqual" style="background: #251e1e;
    color: #fff;display: none;">
    <div class="container">
        <div class="row">
            <div class="interstitial__content">

                <!-- <h1 class="interstitial-heading">Propira is home to one of the most creative, exciting and forward-thinking working communities in Alwar.</h1> -->

                <div class="interstitial-text">
                    <p><span><span>Our approach to design is more considered, more sophisticated and more understated so
                                what we offer is a platform for your brand, never ours.</span></span>
                    </p>
                </div>

                <div><a href="#" class="btn btn--inverse" style="border: 1px solid #fff;color:#fff ">Find your next
                        workspace</a></div>
            </div>
        </div>
    </div>
</div>

<section class="filter-slider newpaddEqual pb-0 mb-0" *ngIf="trendingProjects.length>0">
    <div class="container-fluid">
        <div class="container">
            <div class="row mx-0 align-items-end">
                <div class="col-8 pl-0">
                    <div class="newSec-heading">
                        <h2 style="font-size:28px">Top Projects</h2>
                        <h3 class="m-0">Exclusive showcase of top projects</h3>
                    </div>
                </div>
                <div class="col pr-0">
                    <div class="propria-body text-center w-auto float-right p-0">
                        <div class="">
                            <a class="text-dark viewAllBtn position-relative" (click)="top_View_All()" href="javascript:void(0)" routerLink="/project/top/{{getSelectedCity.slug}}">View All</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blog-box">
                <div class="filter1 filter11 mb-0">
                    <div class=" col-12" *ngFor="let trendproject of trendingProjects">
                        <a routerLink="/project/{{trendproject.project_slug}}" class="property-slid-card d-block overflow-hidden">
                            <div class="img-card w-100">
                                <img alt="" class="img css-20rqfc w-100 h-100" lazyLoad="{{ trendproject.photo }}" defaultImage="assets/images/propira-default.webp">
                            </div>
                            <div class="text-card">
                                <div class="name-price-head d-flex justify-content-between">
                                    <h1 class="d-flex">{{trendproject.project_name | titlecase}}<span class="overflow-hidden">By {{trendproject.builder_name |
                                            titlecase}}</span></h1>
                                    <h2 class="d-flex text-right">₹ {{trendproject.price_from}} - {{trendproject.price_to}} <span>Price</span></h2>
                                </div>
                                <div class="propertyType">
                                    <p class="d-flex mb-3">{{trendproject.configurations}} </p>
                                </div>
                                <div class="name-price-details">
                                    <h3 class="m-0 d-flex">{{trendproject.location}}</h3>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="filter-slider" *ngIf="featuredProjects.length>0">
    <div class="container-fluid">
        <div class="container">
            <div class="row mx-0 align-items-end">
                <div class="col-8 pl-0">
                    <div class="newSec-heading">
                        <h1>Trending Projects</h1>
                        <h3 class="m-0">Trending Projects</h3>
                    </div>
                </div>
                <div class="col pr-0">
                    <div class="propria-body text-center w-auto float-right p-0">
                        <div class="">
                            <a class="text-dark viewAllBtn position-relative" (click)="trending_View_All()" href="javascript:void(0)" routerLink="/project/trending/{{getSelectedCity.slug}}">View All</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blog-box">
                <div class="filter filter13">
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12" *ngFor="let project of featuredProjects">
                        <a routerLink="project/{{project.project_slug}}">
                            <div class="col-md-12 prop-ver-card p-0 h-100 overflow-hidden my-3 mx-0">
                                <div class="row mx-0">
                                    <div class="col-md-5 p-0">
                                        <div class="propert-card-img propert-card-img1 w-100">
                                            <img alt="" class="img-fluid w-100 h-100" lazyLoad="{{ project.photo }}" defaultImage="assets/images/propira-default.webp">
                                        </div>
                                    </div>
                                    <div class="col-md-7 p-2">
                                        <div class="propert-card-details">
                                            <div class="name-price-head">
                                                <h1>{{project.project_name | titlecase}}
                                                    <br><span class="overflow-hidden">By {{project.builder_name}}</span></h1>
                                                <div class="add-prop-card">
                                                    <h1 class="m-0">{{project.configurations}}</h1>
                                                    <h2 class="overflow-hidden mb-3">{{project.location}}</h2>
                                                </div>
                                                <h2 class="m-0">{{project.price_from}} - {{project.price_to}}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="filter-slider bgGray0">
    <div class="container-fluid">
        <div class="container">
            <div class="row">
                <div class="newSec-heading">
                    <h2 style="font-size:28px">Facilities for <strong>Property</strong></h2>
                </div>
            </div>
            <div class="blog-box">
                <div class="filter8 filter12">
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                        <a href="assets/images/rent_agreement.docx" class="css-2zuqw3 overflow-hidden my-3 mx-auto p-3 text-center d-block position-relative">
                            <div class="css-dvxmup mb-2 mx-auto">
                                <img src="assets/images/lease.webp" alt="" class="img css-qs4bii img-fluid">
                            </div>
                            <div>
                                <div class="css-h52i13">Rent Agreement</div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                        <a routerLink="/facilities-for-property/{{getSelectedCity.slug}}/vastu-experts" class="css-2zuqw3 overflow-hidden my-3 mx-auto p-3 text-center d-block position-relative">
                            <div class="css-dvxmup mb-2 mx-auto">
                                <img src="assets/images/vastue.webp" alt="" class="img css-qs4bii img-fluid">
                            </div>
                            <div>
                                <div class="css-h52i13">Vastu Expert</div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                        <a routerLink="/facilities-for-property/{{getSelectedCity.slug}}/architects" class="css-2zuqw3 overflow-hidden my-3 mx-auto p-3 text-center d-block position-relative">
                            <div class="css-dvxmup mb-2 mx-auto">
                                <img src="assets/images/architect.webp" alt="" class="img css-qs4bii img-fluid">
                            </div>
                            <div>
                                <div class="css-h52i13">Architects</div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                        <a routerLink="/facilities-for-property/{{getSelectedCity.slug}}/interior-designer" class="css-2zuqw3 overflow-hidden my-3 mx-auto p-3 text-center d-block position-relative">
                            <div class="css-dvxmup mb-2 mx-auto">
                                <img src="assets/images/designer.webp" alt="" class="img css-qs4bii img-fluid">
                            </div>
                            <div>
                                <div class="css-h52i13">Interior Designer</div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                        <a routerLink="/facilities-for-property/{{getSelectedCity.slug}}/civil-contractor" class="css-2zuqw3 overflow-hidden my-3 mx-auto p-3 text-center d-block position-relative">
                            <div class="css-dvxmup mb-2 mx-auto">
                                <img src="assets/images/civi_contract.webp" alt="" class="img css-qs4bii img-fluid">
                            </div>
                            <div>
                                <div class="css-h52i13">Civil Contractor</div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                        <a routerLink="/facilities-for-property/{{getSelectedCity.slug}}/electrician" class="css-2zuqw3 overflow-hidden my-3 mx-auto p-3 text-center d-block position-relative">
                            <div class="css-dvxmup mb-2 mx-auto">
                                <img src="assets/images/electrician.webp" alt="" class="img css-qs4bii img-fluid">
                            </div>
                            <div>
                                <div class="css-h52i13">Electrician</div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                        <a routerLink="/facilities-for-property/{{getSelectedCity.slug}}/plumber" class="css-2zuqw3 overflow-hidden my-3 mx-auto p-3 text-center d-block position-relative">
                            <div class="css-dvxmup mb-2 mx-auto">
                                <img src="assets/images/plumber.webp" alt="" class="img css-qs4bii img-fluid">
                            </div>
                            <div>
                                <div class="css-h52i13">Plumber</div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                        <a routerLink="/facilities-for-property/{{getSelectedCity.slug}}/carpenter" class="css-2zuqw3 overflow-hidden my-3 mx-auto p-3 text-center d-block position-relative">
                            <div class="css-dvxmup mb-2 mx-auto">
                                <img src="assets/images/carpenter.webp" alt="" class="img css-qs4bii img-fluid">
                            </div>
                            <div>
                                <div class="css-h52i13">Carpenter</div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                        <a routerLink="/facilities-for-property/{{getSelectedCity.slug}}/painter" class="css-2zuqw3 overflow-hidden my-3 mx-auto p-3 text-center d-block position-relative">
                            <div class="css-dvxmup mb-2 mx-auto">
                                <img src="assets/images/painter.webp" alt="" class="img css-qs4bii img-fluid">
                            </div>
                            <div>
                                <div class="css-h52i13">Painter</div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                        <a routerLink="/facilities-for-property/{{getSelectedCity.slug}}/ac-fridge-service" class="css-2zuqw3 overflow-hidden my-3 mx-auto p-3 text-center d-block position-relative">
                            <div class="css-dvxmup mb-2 mx-auto">
                                <img src="assets/images/acfridge.webp" alt="" class="img css-qs4bii img-fluid">
                            </div>
                            <div>
                                <div class="css-h52i13">AC/ Fridge Service</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Latest Properties For Sale In Alwar -->
<div class="container-fluid paddEqual bgGray0 position-relative">
    <div class="container">
        <div class="row ">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <div class="tg-promobox w-100 mx-auto mb-4 text-center ">
                    <div class="tg-theme-heading p-0 m-0 position-relative">
                        <h2 style="font-size:28px" class="m-0 ">Latest Properties For Sale IN {{getSelectedCity.name}}</h2>
                    </div>
                    <h3 style="font-size: 18px;font-weight: 700;color: #3b4144;" class="mt-2 mb-3">Take a look at our current trending properties.</h3>
                </div>
            </div>
        </div>
        <div class="row pdd-0">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <ul class="nav nav-pills property-type-tab latest-property justify-content-center" role="tablist">
                    <li class="nav-item resi active">
                        <a class="nav-link text-white active" data-item="resi" data-toggle="tab" href="#ResidentialDiv">Residential</a>
                    </li>
                    <li class="nav-item  comm">
                        <a class="nav-link text-white" data-item="comm" data-toggle="tab" href="#CommercialDiv">Commercial</a>
                    </li>
                    <li class="nav-item agri">
                        <a class="nav-link text-white" data-item="agri" data-toggle="tab" href="#AgricultureDiv">Agriculture</a>
                    </li>
                    <li class="nav-item indus">
                        <a class="nav-link text-white" data-item="indus" data-toggle="tab" href="#IndustrialDiv">Industrial</a>
                    </li>
                </ul>

                <div class="tab-content certfied-property">

                    <div class="tab-pane fade active show" id="ResidentialDiv">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="resiVerifyProperties.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>
                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of resiVerifyProperties;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoR{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img lazyLoad="{{ image.img_path }}" defaultImage="assets/images/propira-default.webp" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoR{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoR{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Sale</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <a target="_blank" href="{{ verifyp.property_slug }}">
                                            <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                                {{verifyp.property_title | titlecase}} </h6>
                                        </a>
                                        <p><b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;
                                            <small>₹{{verifyp.priceper_unitvalue}}</small>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class=" list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mx-0">
                            <div class="col-12">
                                <div class="propertySaleRent mt-3 text-center w-auto">
                                    <div class="">
                                        <a class="text-white viewAllBtn position-relative px-3 py-1" (click)="latest_View_all()" href="javascript:void(0)" routerLink="/buy/residential-property-for-sale-in-{{getSelectedCity.slug}}">View All</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="tab-pane fade" id="CommercialDiv">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="commVerifyProperties.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>


                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of commVerifyProperties;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoC{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image.img_path }}" loading="lazy" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoC{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoC{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Sale</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <a target="_blank" href="{{ verifyp.property_slug }}">
                                            <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                                {{verifyp.property_title | titlecase}} </h6>
                                        </a>
                                        <p><b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;
                                            <small>₹{{verifyp.priceper_unitvalue}}</small>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class=" list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mx-0">
                            <div class="col-12">
                                <div class="propertySaleRent mt-3 text-center w-auto">
                                    <div class="">
                                        <a class="text-white viewAllBtn position-relative px-3 py-1" href="javascript:void(0)" routerLink="/buy/commercial-property-for-sale-in-{{getSelectedCity.slug}}">View All</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="tab-pane fade" id="AgricultureDiv">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="agriVerifyProperties.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>


                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of agriVerifyProperties;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoA{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image.img_path }}" loading="lazy" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoA{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoA{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Sale</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <a target="_blank" href="{{ verifyp.property_slug }}">
                                            <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                                {{verifyp.property_title | titlecase}} </h6>
                                        </a>
                                        <p><b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;
                                            <small>₹{{verifyp.priceper_unitvalue}}</small>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class="list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="propria-body view-more">
                                <div class="flats-catego">
                                    <a href="javascript:void(0)" routerLink="/search/buy/agriculture">View All</a>
                                </div>
                            </div> -->
                        </div>


                        <div class="row mx-0">
                            <div class="col-12">
                                <div class="propertySaleRent mt-3 text-center w-auto">
                                    <div class="">
                                        <a class="text-white viewAllBtn position-relative px-3 py-1" href="javascript:void(0)" routerLink="/buy/agriculture-for-sale-in-{{getSelectedCity.slug}}">View All</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="tab-pane fade" id="IndustrialDiv">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="indusVerifyProperties.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>


                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of indusVerifyProperties;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoI{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image.img_path }}" loading="lazy" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoI{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoI{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Sale</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                            {{verifyp.property_title | titlecase}} </h6>
                                        <p><b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;
                                            <small>₹{{verifyp.priceper_unitvalue}}</small>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <!--<div class="by-build">{{verifyp.property_type}}</div>-->
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class="list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div class="row mx-0">
                            <div class="col-12">
                                <div class="propertySaleRent mt-3 text-center w-auto">
                                    <div class="">
                                        <a class="text-white viewAllBtn position-relative px-3 py-1" href="javascript:void(0)" routerLink="/buy/industrial-property-for-sale-in-{{getSelectedCity.slug}}">View All</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid paddEqual post-property">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <div class="tg-promobox w-100 mx-auto mb-4 text-center ">
                    <div class="tg-theme-heading p-0 m-0 position-relative">
                        <h2 class="m-0">Thousands of Property Seekers, Delivered to You in One Place.</h2>
                    </div>
                    <h3 class="text-white mt-2 mb-3">Let Propira make the job of finding quality leads for your property hassle-free.</h3>
                    <a class="d-inline-block bg-white py-2 px-3" (click)="post_property()" routerLink="/quick-listing">Post Your Property</a>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Latest Propira Properties For Rent In Alwar -->
<div class="container-fluid paddEqual bgGray position-relative">
    <div class="container">
        <div class="row ">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <div class="tg-promobox w-100 mx-auto mb-4 text-center ">
                    <div class="tg-theme-heading p-0 m-0 position-relative">
                        <h2 style="font-size:28px" class="m-0">Latest Properties For Rent IN {{getSelectedCity.name}}</h2>
                    </div>
                    <h3 style="font-size: 18px;font-weight: 700;color:#3b4144;" class="mt-2 mb-3">Take a look at our current trending properties.</h3>
                </div>
            </div>
        </div>
        <div class="row pdd-0">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <ul class="nav nav-pills property-type-tab latest-property justify-content-center" role="tablist">
                    <li class="nav-item resi active">
                        <a class="nav-link active" data-item="resi" data-toggle="tab" href="#RentResidentialDiv">Residential</a>
                    </li>
                    <li class="nav-item  comm">
                        <a class="nav-link" data-item="comm" data-toggle="tab" href="#RentCommercialDiv">Commercial</a>
                    </li>
                    <li class="nav-item agri">
                        <a class="nav-link" data-item="agri" data-toggle="tab" href="#RentAgricultureDiv">Agriculture</a>
                    </li>
                    <li class="nav-item indus">
                        <a class="nav-link" data-item="indus" data-toggle="tab" href="#RentIndustrialDiv">Industrial</a>
                    </li>
                </ul>

                <div class="tab-content certfied-property">

                    <div class="tab-pane fade active show" id="RentResidentialDiv">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="resiVerifyPropertiesRent.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>
                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of resiVerifyPropertiesRent;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoR{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img lazyLoad="{{ image.img_path }}" defaultImage="assets/images/propira-default.webp" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoR{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoR{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Rent</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <a target="_blank" href="{{ verifyp.property_slug }}">
                                            <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                                {{verifyp.property_title | titlecase}} </h6>
                                        </a>
                                        <p><b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;
                                            <small>₹{{verifyp.priceper_unitvalue}}</small>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class=" list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mx-0">
                            <div class="col-12">
                                <div class="propertySaleRent mt-3 text-center w-auto">
                                    <div class="">
                                        <a class="text-white viewAllBtn position-relative px-3 py-1" href="javascript:void(0)" (click)="latest_rent_View_all()" routerLink="/rent/residential-property-for-rent-in-{{getSelectedCity.slug}}">View All</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="tab-pane fade" id="RentCommercialDiv">

                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="commVerifyPropertiesRent.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>


                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of commVerifyPropertiesRent;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoC{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image.img_path }}" loading="lazy" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoC{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoC{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Rent</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <a target="_blank" href="{{ verifyp.property_slug }}">
                                            <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                                {{verifyp.property_title | titlecase}} </h6>
                                        </a>
                                        <p><b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;
                                            <small>₹{{verifyp.priceper_unitvalue}}</small>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class=" list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mx-0">
                            <div class="col-12">
                                <div class="propertySaleRent mt-3 text-center w-auto">
                                    <div class="">
                                        <a class="text-white viewAllBtn position-relative px-3 py-1" href="javascript:void(0)" routerLink="/rent/commercial-property-for-rent-in-{{getSelectedCity.slug}}">View All</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="tab-pane fade" id="RentAgricultureDiv">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="agriVerifyPropertiesRent.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>


                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of agriVerifyPropertiesRent;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoA{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image.img_path }}" loading="lazy" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoA{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoA{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Rent</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <a target="_blank" href="{{ verifyp.property_slug }}">
                                            <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                                {{verifyp.property_title | titlecase}} </h6>
                                        </a>
                                        <p><b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;
                                            <small>₹{{verifyp.priceper_unitvalue}}</small>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class=" list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mx-0">
                            <div class="col-12">
                                <div class="propertySaleRent mt-3 text-center w-auto">
                                    <div class="">
                                        <a class="text-white viewAllBtn position-relative px-3 py-1" href="javascript:void(0)" routerLink="/rent/agriculture-for-rent-in-{{getSelectedCity.slug}}">View All</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="tab-pane fade" id="RentIndustrialDiv">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="indusVerifyPropertiesRent.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>


                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of indusVerifyPropertiesRent;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoI{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image.img_path }}" loading="lazy" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoI{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoI{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Rent</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                            {{verifyp.property_title | titlecase}} </h6>
                                        <p><b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;
                                            <small>₹{{verifyp.priceper_unitvalue}}</small>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <!--<div class="by-build">{{verifyp.property_type}}</div>-->
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class=" list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div class="row mx-0">
                            <div class="col-12">
                                <div class="propertySaleRent mt-3 text-center w-auto">
                                    <div class="">
                                        <a class="text-white viewAllBtn position-relative px-3 py-1" href="javascript:void(0)" routerLink="/rent/industrial-property-for-rent-in-{{getSelectedCity.slug}}">View All</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Sold Properties -->

<div class="container-fluid paddEqual bgGray d-none">
    <div class="container">
        <div class="row ">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <div class="tg-promobox w-100 mx-auto mb-4 text-center ">
                    <div class="tg-theme-heading p-0 m-0 position-relative">
                        <h3 class="m-0">Sold Properties</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pdd-0">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <div class="tab-content certfied-property">

                    <div class="tab-pane fade active show" id="ResidentialDivRent">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="resiVerifyPropertiesRent.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>
                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let sold of soldProperties; let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ sold.property_slug }}">
                                        <figure>
                                            <div id="demoW{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of sold.images;let first=first;" [ngClass]="{active: first}">
                                                        <img lazyLoad="{{ image.img_path }}" defaultImage="assets/images/propira-default.webp" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoW{{i}}" data-slide="prev" *ngIf="sold.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoW{{i}}" data-slide="next" *ngIf="sold.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span>For Sale</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{sold.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="sold.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{sold.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <a target="_blank" href="{{ sold.property_slug }}">
                                            <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{sold.property_title | titlecase}}">
                                                {{sold.property_title | titlecase}} </h6>
                                        </a>
                                        <p>
                                            <b>₹{{sold.priceinshort_words}}</b>&nbsp;&nbsp;
                                            <b>₹{{sold.priceper_unitvalue}}</b>
                                        </p>
                                        <div class="by-build">Area: <b> {{sold.show_area}} </b></div>
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ sold.property_slug }}">See
                                                Details</a>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{sold.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="propria-body view-more">
                                <div class="flats-catego">
                                    <a class="text-dark viewAllBtn position-relative px-3" href="javascript:void(0)" routerLink="/sales-properties/all/{{getSelectedCity.slug}}">View All</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="CommercialDivRent">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="commVerifyPropertiesRent.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>


                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of commVerifyPropertiesRent;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoX{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image.img_path }}" loading="lazy" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoX{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoX{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Rent</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <a target="_blank" href="{{ verifyp.property_slug }}">
                                            <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                                {{verifyp.property_title | titlecase}} </h6>
                                        </a>
                                        <p>
                                            <!--<b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;-->
                                            <b>₹{{verifyp.priceper_unitvalue}}</b>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class=" list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="propria-body view-more">
                                <div class="flats-catego">
                                    <a href="javascript:void(0)" routerLink="/search/rent/commercial/{{getSelectedCity.slug}}">View All</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="AgricultureDivRent">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="agriVerifyPropertiesRent.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>


                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of agriVerifyPropertiesRent;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoY{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image.img_path }}" loading="lazy" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoY{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoY{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Rent</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <a target="_blank" href="{{ verifyp.property_slug }}">
                                            <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                                {{verifyp.property_title | titlecase}} </h6>
                                        </a>
                                        <p>
                                            <!--<b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;-->
                                            <b>₹{{verifyp.priceper_unitvalue}}</b>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class=" list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="propria-body view-more">
                                <div class="flats-catego">
                                    <a href="javascript:void(0)" routerLink="/search/rent/agriculture/{{getSelectedCity.slug}}">View All</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="IndustrialDivRent">
                        <div class="featured-item row" style="margin:0px">
                            <div *ngIf="indusVerifyPropertiesRent.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:10%">
                                <p>Property Not Found.</p>
                            </div>


                            <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 " *ngFor="let verifyp of indusVerifyPropertiesRent;let i=index;">
                                <div class="propria-prop-content">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <figure>
                                            <div id="demoZ{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                                <div class="carousel-inner">
                                                    <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image.img_path }}" loading="lazy" class="img-fluid" alt="listing image" style="width: 100%">
                                                    </div>
                                                </div>
                                                <a class="carousel-control-prev" href="#demoZ{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-left"></i>
                                                </a>
                                                <a class="carousel-control-next" href="#demoZ{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                    <i class="ti-angle-right"></i>
                                                </a>
                                            </div>
                                            <div class="ribbon position-absolute overflow-hidden verified">
                                                <span class="position-absolute d-block py-1 px-0 text-white text-center">For Rent</span>
                                            </div>
                                            <div class="image-overlay"></div>
                                            <span class="list-loc"><i class="ti-location-pin"></i>
                                                {{verifyp.location}}</span>
                                            <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                    class="ti-camera"></i>
                                                {{verifyp.images.length}}</span>
                                        </figure>
                                    </a>
                                    <div class="propria-body">
                                        <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                            {{verifyp.property_title | titlecase}} </h6>
                                        <p>
                                            <!--<b>₹{{verifyp.priceinshort_words}}</b>&nbsp;&nbsp;-->
                                            <b>₹{{verifyp.priceper_unitvalue}}</b>
                                        </p>
                                        <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                        <!--<div class="by-build">{{verifyp.property_type}}</div>-->
                                        <div class="flats-catego by-build">
                                            <a target="_blank" href="{{ verifyp.property_slug }}">See
                                                Details</a>
                                            <div class="listing_actions">
                                                <div class="share_unit d-none">
                                                    <ul class=" list-unstyled">
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('google',verifyp.property_slug)"><i
                                                                    class="fa  fa-google"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('facebook',verifyp.property_slug)"><i
                                                                    class="ti-facebook"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('instagram',verifyp.property_slug)"><i
                                                                    class="ti-instagram"></i></a>
                                                        </li>
                                                        <li class=""><a href="javascript: void(0);" (click)="sharePost('whatsup',verifyp.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span class="sharethis"><i class="ti-sharethis"></i></span>

                                                <span *ngIf="!verifyp.propertyof_user">
                                                    <i class="testsss fa fa-heart"
                                                        id="latesetwishlist{{verifyp.property_id}}"
                                                        [ngClass]="chkPropertyWishlistId.includes(verifyp.property_id) ? 'fa-heart':'fa-heart-o'"
                                                        (click)="addToWishlist('2',verifyp.property_id,$event)"></i>
                                                    <i class="fa fa-spinner fa-spin"
                                                        id="latesetloader{{verifyp.property_id}}"
                                                        style="color:red;display:none"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="by-build">
                                            <div class="property-agent">
                                                Posted on {{verifyp.posted_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="propria-body view-more">
                                <div class="flats-catego">
                                    <a href="javascript:void(0)" routerLink="/search/rent/industrial/{{getSelectedCity.slug}}">View All</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>





<section class="filter-slider newpaddEqual" *ngIf="topBrokers.length>0">
    <div class="container-fluid">
        <div class="container">
            <div class="row align-items-end">
                <div class="col-12 col-sm-auto ">
                    <div class="newSec-heading col-md-12 p-0">
                        <h2 style="font-size:28px">Our Property Experts</h2>
                        <h3 class="m-0">Agents with Complete Knowledge About Properties</h3>
                    </div>
                </div>
                <div class="col-12 col-sm pr-0">
                    <div class="propria-body text-center w-auto float-right p-0">
                        <div class="">
                            <a class="text-dark viewAllBtn position-relative" href="javascript:void(0)" (click)="property_expert_view_all()" routerLink="/agent/{{getSelectedCity.slug}}">View All</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blog-box">
                <div class="filter4 filter14">
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 pr-0" *ngFor="let broker of topBrokers">
                        <a target="_blank" class="css-19pbx2v mr-3 w-100 d-block my-0 p-2" routerLink="/agent/{{getSelectedCity.slug}}/{{broker.company_slug}}">
                            <div class="css-gg4vpm d-flex justfy-content-between">
                                <div class="thumbnail-wrapper css-episjk overflow-hidden rounded-pill position-relative"><img lazyLoad="{{broker.photo}}" defaultImage="assets/images/propira-default.webp" class="image css-10qiwim h-100" alt="GK" decoding="async">
                                </div>
                                <div class="css-1t6yj5d pl-2">
                                    <div class="css-188gsfr w-100 d-block overflow-hidden">{{(broker.company_name).substring(0,18)}}</div>
                                    <div class="css-vf73pw d-inline-block text-white px-1 mt-1">Property Expert</div>
                                    <div class="css-oc1vt3 d-flex mt-1">
                                        <div class="css-1peufed ml-0 mr-2">
                                            <div class="css-10rvbm3">{{broker.working_experience}} Years</div>
                                            <div class="css-1e4gujc">Experience</div>
                                        </div>
                                        <div class="css-1peufed pr-0 border-right-0 border-left-1 border-dark ml-2">
                                            <div class="css-10rvbm3">{{broker.property_count}}</div>
                                            <div class="css-1e4gujc">Properties</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="css-1jwfwud mt-2 d-flex justfy-content-left">
                                <span class="css-9e9nds d-inline-block w-auto overflow-hidden mr-1 px-2"><i class="ti-location-pin"></i>
                                    {{broker.office_address}}</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="ccontainer-fluid paddEqual what-makes-us bgGray position-relative text-white">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <div class="tg-promobox w-100 mx-auto mb-4 text-center ">
                    <div class="tg-theme-heading p-0 m-0 position-relative">
                        <h2 class="m-0">Your Local Property Expert</h2>
                    </div>
                    <h3 class="mt-2 mb-3">Why Us?</h3>
                    <div class="heading-div">
                        <i class="ti-home position-relative px-1 py-0"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mx-auto">
                <ul class="preferred-choice">
                    <li>
                        <i class="ti-check-box"></i>
                        <h5>Free Assistance</h5>
                        <p>We will help you to navigate through the tough terrains of legal and documentation.</p>
                    </li>
                    <li>
                        <i class="ti-bookmark-alt"></i>
                        <h5>Credibility Assurance</h5>
                        <p>We work only with genuine prospects and regularly filter the solid ones from spam.</p>
                    </li>
                    <li>
                        <i class="ti-thumb-up"></i>
                        <h5>Time-Saving</h5>
                        <p>We remove the clutter and bring you to the ones who are genuinely interested to deal with you.
                        </p>
                    </li>
                    <li>
                        <i class="ti-headphone"></i>
                        <h5>End-to-end Support</h5>
                        <p>Anything suspicious or little out-of-the-place, don’t worry, Propira Hai Na!</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid p-0 overflow-hidden text-white" id="about-us-div" style="display: none">
    <div class="container">
        <div class="row ">
            <div class="col-lg-5 col-xl-5 offset-xl-6 col-md-5 col-sm-5 col-12 about-box">
                <div class="tg-theme-heading p-0 m-0 position-relative">
                    <h3 class="m-0">About Us</h3>
                </div>
                <p>Propira is your local property expert. Propira helps you find the best properties to buy, sell or rent in your location of choice. With its huge database of trusted buyers and sellers, Propira offers a secure and authentic one-stop solution
                    to those looking for the best properties around them. </p>

                <a class="text-white d-inline-block py-2 px-3" routerLink="/about-us">Read More</a>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid text-white py-5 px-0" id="testimonial-area" *ngIf="testimonialList.length>0">
    <div class="container p-0">
        <div class="tg-promobox w-100 mx-auto mb-4 text-center ">
            <div class="tg-theme-heading p-0 m-0 position-relative">
                <h2 style="font-size:28px" class="m-0 text-white">The Propira Family, Always a Step Ahead</h2>
            </div>
        </div>
        <div class="row" style="max-width: 95%;margin: auto;">
            <div class="col-sm-12  col-md-12 col-lg-12 firstHalf add-ouiters">
                <div id="carousel-example" class="carousel slide" active="0" data-ride="carousel" data-interval="3000">
                    <div class="carousel-inner">
                        <div *ngFor="let testimonial of testimonialList;let i=index" class="carousel-item" [class.active]="i==0">
                            <div class="truncate">
                                <div class="testimonial-img-outer">
                                    <img lazyLoad="{{ testimonial.image }}" defaultImage="assets/images/propira-default.webp" class="img-fluid" alt="testimonial">
                                </div>
                                <div class="testitext">
                                    <p class="text truncatetestimonial"><span>{{testimonial.description}}"</span></p>
                                    <h4>{{ testimonial.client_name }} &nbsp;<small>{{ testimonial.designation }}</small>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <ol class="carousel-indicators m-0">
                            <li class="ml-1 my-0 mr-0 border-0 position-relative overflow-hidden rounded-pill" data-target="#carousel-example" *ngFor="let testimonial of testimonialList;let i=index;" [attr.data-slide-to]="i" [class.active]="i==0">
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid paddEqual propiraBlog bgGray blog-bg position-relative">
    <div class="container">
        <div class="row ">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <div class="tg-promobox w-100 mx-auto mb-4 text-center ">
                    <div class="tg-theme-heading p-0 m-0 position-relative">
                        <h2 class="m-0">The Propira Blog</h2>
                    </div>
                    <h3 class="mt-2 mb-3">Information, insights, and Innovation - All in one place</h3>
                    <div class="heading-div">
                        <i class="ti-home position-relative px-1 py-0"></i>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="min-outer-view mt-0" style="text-align:right; margin-bottom: 10px;">
                    <a class="text-dark viewAllBtn position-relative p-0 mt-0 d-inline-block border-0" (click)="blog_view_all()" routerLink="/blog">
                        <span>View All</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="blog-box">
            <div class="latest-blog mt-0 mb-4">
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 " *ngFor="let blog of blogList;let last=last">
                    <a routerLink="/blog/{{blog.slug}}">
                        <div class="propira-blog m-0 w-100 float-left bg-white">
                            <figure class="overflow-hidden w-50 float-left m-0">
                                <img lazyLoad="{{ blog.image }}" defaultImage="assets/images/propira-default.webp" class="img-fluid" alt="listing image">
                            </figure>
                            <div class="blog-body w-50 float-left">
                                <h6 class="mb-3">{{blog.blog_title}}</h6>
                                <p class="blog-text mb-5">
                                    {{ ((blog.short_description).length>90)? (blog.short_description | slice:0:90)+'..':(blog.short_description) }}
                                </p>
                                <p>
                                    <span class="blog-btn mr-3">Read More</span>
                                    <span class="mr-3"><i class="ti-calendar mr-1"></i> {{blog.date}}</span>
                                    <span class="mr-3"><i class="ti-user mr-1"></i> {{blog.author_name}}</span>
                                </p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid position-relative py-5 px-0" id="number-counter" *ngIf="propertysnapshot" style="display: none">
    <div class="container">
        <div class="row ">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <div class="tg-promobox w-100 mx-auto mb-4 text-center">
                    <div class="tg-theme-heading p-0 m-0 position-relative">
                        <h3 class="m-0">Property Snapshot</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="row p-0">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                <div class="tg-counter w-100 float-left text-center">
                    <h2 class="mt-3 mb-2"><span class="count">{{propertysnapshot.property_listed}}</span><span>+</span></h2>
                    <h4 class="text-center">Properties Listed</h4>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                <div class="tg-counter w-100 float-left text-center">
                    <h2 class="mt-3 mb-2"><span class="count">{{propertysnapshot.property_locations}}</span><span>+</span></h2>
                    <h4 class="text-center">Locations</h4>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                <div class="tg-counter w-100 float-left text-center">
                    <h2 class="mt-3 mb-2"><span class="count">{{propertysnapshot.property_buyers}}</span><span>+</span></h2>
                    <h4 class="text-center">Buyers</h4>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                <div class="tg-counter w-100 float-left text-center">
                    <h2 class="mt-3 mb-2"><span class="count">{{propertysnapshot.property_sellers}}</span><span>+</span></h2>
                    <h4 class="text-center">Sellers</h4>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="addProperty" id="propertysuddenpopup">
    <div class="postProperty">
        <div class="alert alert-primary alert-dismissible books-alert blink-book-alert">
            <button type="button" class="close closesuddenpopup" data-dismiss="alert">×</button>
            <p class="text-center">
                <a style="cursor:pointer" routerLink="/quick-listing"><i class="ti-pencil-alt"></i> Post
                    Your Property</a>
            </p>
        </div>
    </div>
</div>